import React from 'react';
import { useNavigate } from 'react-router-dom';
import Table from '../components/Table';
import { useDeleteVideoMutation, useGetAllVideosQuery } from '../features/video/videoApi';

const Videos = () => {
  const tableHead=['Video Title','Description','Action'];

  const {data:videos,isError,isLoading,isSuccess,error}=useGetAllVideosQuery();
  const[deleteVideo, {}]=useDeleteVideoMutation();

 const tableKeyNames=['title','description'];
 const navigate=useNavigate();

 const handleEdit=(id)=>{
navigate(`/admin/videos/edit/${id}`)
 }

 const handleDelete=(id)=>{
  deleteVideo(id)
 }

  return (
    <>
   <section className="py-6 bg-primary">
  <div className="mx-auto max-w-full px-5 lg:px-20">
    <div className="px-3 py-20 bg-opacity-10">
      <div className="w-full flex">
        <button className="btn ml-auto" onClick={()=>navigate('/admin/videos/add')}>Add Video</button>
      </div>
     

<Table handleEdit={handleEdit} handleDelete={handleDelete} tableHead={tableHead} data={videos} tableKeyNames={tableKeyNames} showDelete={true}  showEdit={true} isSuccess={isSuccess} isError={isError} isLoading={isLoading}/>

    </div>
  </div>
</section>

    </>
  )
}

export default Videos